import cityLagLat from './baseData/chinaCity.json';

let data = [{
        "流出省份": "湖北省",
        "流出城市": "武汉",
        "流入省份": "河南省",
        "数量": "408678",
        "占比": "12.39%"
    },
    {
        "流出省份": "湖北省",
        "流出城市": "武汉",
        "流入省份": "广东省",
        "数量": "349144",
        "占比": "10.59%"
    },
    {
        "流出省份": "湖北省",
        "流出城市": "武汉",
        "流入省份": "湖南省",
        "数量": "261355",
        "占比": "7.92%"
    },
    {
        "流出省份": "湖北省",
        "流出城市": "武汉",
        "流入省份": "江苏省",
        "数量": "188055",
        "占比": "5.70%"
    },
    {
        "流出省份": "湖北省",
        "流出城市": "武汉",
        "流入省份": "安徽省",
        "数量": "177816",
        "占比": "5.39%"
    },
    {
        "流出省份": "湖北省",
        "流出城市": "武汉",
        "流入省份": "四川省",
        "数量": "168709",
        "占比": "5.12%"
    },
    {
        "流出省份": "湖北省",
        "流出城市": "武汉",
        "流入省份": "江西省",
        "数量": "165454",
        "占比": "5.02%"
    },
    {
        "流出省份": "湖北省",
        "流出城市": "武汉",
        "流入省份": "山东省",
        "数量": "157416",
        "占比": "4.77%"
    },
    {
        "流出省份": "湖北省",
        "流出城市": "武汉",
        "流入省份": "浙江省",
        "数量": "152962",
        "占比": "4.64%"
    },
    {
        "流出省份": "湖北省",
        "流出城市": "武汉",
        "流入省份": "北京市",
        "数量": "131386",
        "占比": "3.98%"
    },
    {
        "流出省份": "湖北省",
        "流出城市": "武汉",
        "流入省份": "河北省",
        "数量": "123183",
        "占比": "3.74%"
    },
    {
        "流出省份": "湖北省",
        "流出城市": "武汉",
        "流入省份": "上海市",
        "数量": "112917",
        "占比": "3.42%"
    },
    {
        "流出省份": "湖北省",
        "流出城市": "武汉",
        "流入省份": "福建省",
        "数量": "102151",
        "占比": "3.10%"
    },
    {
        "流出省份": "湖北省",
        "流出城市": "武汉",
        "流入省份": "重庆市",
        "数量": "93010",
        "占比": "2.82%"
    },
    {
        "流出省份": "湖北省",
        "流出城市": "武汉",
        "流入省份": "广西壮族自治区",
        "数量": "82186",
        "占比": "2.49%"
    },
    {
        "流出省份": "湖北省",
        "流出城市": "武汉",
        "流入省份": "陕西省",
        "数量": "81465",
        "占比": "2.47%"
    },
    {
        "流出省份": "湖北省",
        "流出城市": "武汉",
        "流入省份": "山西省",
        "数量": "74647",
        "占比": "2.26%"
    },
    {
        "流出省份": "湖北省",
        "流出城市": "武汉",
        "流入省份": "贵州省",
        "数量": "65905",
        "占比": "2.00%"
    },
    {
        "流出省份": "湖北省",
        "流出城市": "武汉",
        "流入省份": "辽宁省",
        "数量": "60213",
        "占比": "1.83%"
    },
    {
        "流出省份": "湖北省",
        "流出城市": "武汉",
        "流入省份": "云南省",
        "数量": "57124",
        "占比": "1.73%"
    },
    {
        "流出省份": "湖北省",
        "流出城市": "武汉",
        "流入省份": "黑龙江省",
        "数量": "43008",
        "占比": "1.30%"
    },
    {
        "流出省份": "湖北省",
        "流出城市": "武汉",
        "流入省份": "甘肃省",
        "数量": "39505",
        "占比": "1.20%"
    },
    {
        "流出省份": "湖北省",
        "流出城市": "武汉",
        "流入省份": "海南省",
        "数量": "39498",
        "占比": "1.20%"
    },
    {
        "流出省份": "湖北省",
        "流出城市": "武汉",
        "流入省份": "新疆维吾尔自治区",
        "数量": "35865",
        "占比": "1.09%"
    },
    {
        "流出省份": "湖北省",
        "流出城市": "武汉",
        "流入省份": "吉林省",
        "数量": "33172",
        "占比": "1.01%"
    },
    {
        "流出省份": "湖北省",
        "流出城市": "武汉",
        "流入省份": "内蒙古自治区",
        "数量": "31912",
        "占比": "0.97%"
    },
    {
        "流出省份": "湖北省",
        "流出城市": "武汉",
        "流入省份": "天津市",
        "数量": "26767",
        "占比": "0.81%"
    },
    {
        "流出省份": "湖北省",
        "流出城市": "武汉",
        "流入省份": "宁夏回族自治区",
        "数量": "11700",
        "占比": "0.35%"
    },
    {
        "流出省份": "湖北省",
        "流出城市": "武汉",
        "流入省份": "青海省",
        "数量": "8134",
        "占比": "0.25%"
    },
    {
        "流出省份": "湖北省",
        "流出城市": "武汉",
        "流入省份": "台湾省",
        "数量": "4338",
        "占比": "0.13%"
    },
    {
        "流出省份": "湖北省",
        "流出城市": "武汉",
        "流入省份": "香港",
        "数量": "4158",
        "占比": "0.13%"
    },
    {
        "流出省份": "湖北省",
        "流出城市": "武汉",
        "流入省份": "西藏自治区",
        "数量": "3588",
        "占比": "0.11%"
    },
    {
        "流出省份": "湖北省",
        "流出城市": "武汉",
        "流入省份": "澳门",
        "数量": "2635",
        "占比": "0.08%"
    }
];
/**
 * 查询城市
 * @param {*} provinceName 省份名称
 * @param {*} cityName 城市名称
 */
const findCity = (provinceName, cityName) => {
    const province = cityLagLat.find((a) => {
        return provinceName == a.name;
    });
    if (cityName == null) {
        return [province.log, province.lat]
    } else {
        const city = province.children.find((a) => {
            return cityName == a.name;
        });
        return [city.log, city.lat]
    }
}

const result = data.map((item) => {
   
    return {
        from: {
            name: item['流出城市'],
            coordinates: findCity(item['流出省份'], item['流出城市'])
        },
        to: {
            name: item['流入省份'],
            coordinates: findCity(item['流入省份'])
        },
        value: Number(item['数量']),
        _data: {
            ...item
        }
    }
})
 
result.sort((b, a) => {
    return a.value - b.value;
})

export default result;
 